import React, { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { OcTextInputField } from "oc/components";

type TextInputFieldProps = {
  value: string;
  setValue: Dispatch<SetStateAction<string>>;
  error: boolean;
  setError: Dispatch<SetStateAction<boolean>>;
  helperText: string;
  setHelperText: Dispatch<SetStateAction<string>>;
  isValid: () => boolean;
  validate: () => void;
};

type MyHrSSOFormProps = {
  ssoAddress: TextInputFieldProps;
  ssoPort: TextInputFieldProps;
  ssoCN: TextInputFieldProps;
  domainSuffix: TextInputFieldProps;
  systemUserName: TextInputFieldProps;
  systemUserPassword: TextInputFieldProps;
  isMobile: boolean;
};

export const MyHrSSOForm: React.FC<MyHrSSOFormProps> = ({
  ssoAddress,
  ssoPort,
  ssoCN,
  domainSuffix,
  systemUserName,
  systemUserPassword,
  isMobile,
}) => {
  const { t } = useTranslation();

  return (
    <Box paddingTop={isMobile ? "0px" : "36px"}>
      <Box>
        <Box
          width={isMobile ? "auto" : "480px"}
          padding={isMobile ? "0px" : "0px 24px"}
        >
          <Box display="flex" flexDirection="row">
            <OcTextInputField label="URL" {...ssoAddress} />
            <Box width="16px" />
            <Box width="100px">
              <OcTextInputField label="PORT" {...ssoPort} />
            </Box>
          </Box>
          <Box height="36px" />
          <Box>
            <OcTextInputField label="DC" {...ssoCN} />
          </Box>
          <Box height="36px" />
          <Box>
            <OcTextInputField
              label={t("MY_HR_DOMAIN_SUFFIX")}
              {...domainSuffix}
            />
          </Box>
          <Box height="36px" />
          <Box>
            <OcTextInputField
              label={t("MY_HR_SYSTEM_USER_NAME")}
              {...systemUserName}
            />
          </Box>
          <Box height="36px" />
          <Box>
            <OcTextInputField
              label={t("MY_HR_SYSTEM_USER_PASSWORD")}
              {...systemUserPassword}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MyHrSSOForm;
